/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedTradeRewardsBenefitCard_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedTradeRewardsBenefitCardLoader_user$ref: FragmentReference;
export type PdpSharedTradeRewardsBenefitCardLoader_user = {|
  +$fragmentRefs: PdpSharedTradeRewardsBenefitCard_user$ref,
  +$refType: PdpSharedTradeRewardsBenefitCardLoader_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedTradeRewardsBenefitCardLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedTradeRewardsBenefitCard_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c9155c8f859ff8f6867b17953cb75485';
module.exports = node;
